import { useLocale } from "@dgs/core";
import { useMemo } from "react";

export const useFormatPercent = () => {
	const { formatLocale } = useLocale();

	const formatter = useMemo(() => {
		return new Intl.NumberFormat(formatLocale, {
			style: "percent",
			maximumFractionDigits: 2,
		});
	}, [formatLocale]);

	return (value: number) => formatter.format(value);
};
